/* eslint-disable max-lines-per-function */
import Styles from './HeroLogin.module.scss';
import React, { FC, JSX, useEffect, useState } from 'react';
import RichText from '../richtext';
import { HEROBANNER, TYPE } from '../../Analytics/AnalyticsConstants';
import { trackEvent } from '../../utils/AnalyticsUtils';
import Cookies from 'js-cookie';
import { LoginBasicPropConfig } from '../../services/LoginBasicPropConfig';
import LoginModalV2 from '../login/LoginModalV2';

const HeroLoginBanner: FC<any> = ({
  content,
  metadata,
  loginSuccess,
  setLoginSuccess,
  basicConfigUrl,
  isProdEnv,
}): JSX.Element => {
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [close, setclose] = useState<boolean>(false);
  const [isLoginSticky, setIsLoginSticky] = useState<boolean>(false);
  const [scrollDir, setScrollDir] = useState<boolean>(false);
  const [scrollVal, setScrollVal] = useState<number>(0);

  LoginBasicPropConfig.create({ baseURL: basicConfigUrl ?? '' });
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);


  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsLoginSticky(true);
    } else {
      setIsLoginSticky(false);
    }
    if (window.scrollY > scrollVal) {
      setScrollDir(true);
    } else {
      setScrollDir(false);
    }
    setScrollVal(window.scrollY);
  };

  useEffect(() => {
    const session = sessionStorage.getItem('hideBanner');
    session && setclose(!close);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const description =
    HEROBANNER +
    '|' +
    content?.description?.content?.map((item: any) => {
      return item?.content?.[0]?.text;
    });

  const handleClick = () => {
    setclose(!close);
    sessionStorage?.setItem('hideBanner', 'true');
  };

  const toggleShowLogin = () => {
    trackEvent(description, content?.buttonLabel, TYPE);
    setShowLogin(!showLogin);
  };

  const loginStyle = (): any => {
    if (content?.isSticky) {
      if (isLoginSticky) {
        return !scrollDir ? `${Styles.stickyStyleUp}` : `${Styles.stickyStyle} `;
      } else {
        return `${Styles.container}`;
      }
    }
  };

  const onLoginSuccess = () => {
    setLoginSuccess();
    setShowLogin(false);
  };

  const disableAnimation=content?.disableAnimations;
  const hasGlobalGradient = !!content?.gradientBackgroundGlobal;
  const backgroundInlineStyle = hasGlobalGradient
    ? { background: content?.gradientBackgroundGlobal }
    : disableAnimation
    ? { backgroundColor: content?.backgroundColor?.color }
    : undefined;

  const buttonStyleMap: Record<string, string> = {
    sunriseRed: `${Styles.btnStyle} ${!disableAnimation ? Styles.btnanimations : ''}`,
    iceWhite: Styles.btnStyleIceWhite,
    lightBlack: Styles.btnStyleBlack,
  };
  const resolvedButtonClass = (buttonStyleMap[content?.buttonStyles] ?? buttonStyleMap.sunriseRed).trim();

  const descriptionColorMap: Record<string, string> = {
    white: Styles.descriptionColorWhite,
    black: Styles.descriptionColorBlack,
  };
  const resolvedDescriptionColor = descriptionColorMap[content?.descriptionColor] ?? Styles.descriptionColorBlack;

  return (
    <>
      {!AuthData?.siteId && !loginSuccess && (
        <>
          <div className={loginStyle()}>
            <div
              className={`${!close ? Styles.wrapper : Styles.close} ${!disableAnimation ? Styles.animations : ''}`.trim()}
              style={backgroundInlineStyle}
            >
              {content?.closeIcon && (
                <div className={Styles.iconStyle} onClick={handleClick}>
                  <img
                    src={content?.closeIconConfig?.filename ?? '/ecom-int/icons/close_banner.svg'}
                    alt='close'
                  />
                </div>
              )}
              {content?.description && (
                <div className={`${Styles.textStyle} ${resolvedDescriptionColor}`}>
                  <RichText content={content?.description} />
                </div>
              )}
              {content?.buttonLabel && (
                <button className={resolvedButtonClass} onClick={toggleShowLogin}>
                  {content?.buttonLabel}
                </button>
              )}
            </div>
          </div>
          {showLogin && content?.login?.[0] && (
            <LoginModalV2
              content={content?.login?.[0]}
              closeLogin={toggleShowLogin}
              metadata={metadata}
              onSuccess={onLoginSuccess}
              isProdEnv={isProdEnv}
            />
          )}
        </>
      )}
    </>
  );
};

export default HeroLoginBanner;
